// extracted by mini-css-extract-plugin
module.exports = {"sort":"sort__2XUh7","arrow":"arrow__2r3SJ","unsorted":"unsorted__1SNwQ","asc":"asc__1d3_N"};